import type { ListFilter } from "./ListScreen.tsx";

/** The list page's address: the open row (`?row=<key>`) and what the table shows (`?show=`). Kept apart from the
 * page so the route's first chunk stays small. */
const isFilter = (v: unknown): v is ListFilter =>
  typeof v === "string" && (["all", "new", "mine", "free", "dropped"].includes(v) || v.startsWith("state:"));

export const listSearch = (search: Record<string, unknown>): { row?: string; show?: ListFilter } => ({
  ...(typeof search.row === "string" ? { row: search.row } : {}),
  ...(isFilter(search.show) && search.show !== "all" ? { show: search.show } : {}),
});
